import {
  ChatMessageAttachmentType,
  ChatMessagePayloadAttachment,
  InstagramMessageType,
} from "@jugl-web/rest-api";
import { InstagramMessageModel } from "@jugl-web/rest-api/integrations/models/InstagramMessage/InstagramMessageModel";
import { TFunction } from "@jugl-web/utils";
import { environment } from "@web-src/environments/environment";

export const instagramMessageToAttachmentsPayload = ({
  message,
  entityId,
  t,
}: {
  message: InstagramMessageModel;
  entityId: string;
  t: TFunction;
}): ChatMessagePayloadAttachment[] | null => {
  if (
    !("message" in message.payload) ||
    !("msg_type" in message) ||
    message.msg_type === InstagramMessageType.text ||
    ![
      InstagramMessageType.image,
      InstagramMessageType.video,
      InstagramMessageType.audio,
    ].includes(message.msg_type) ||
    !("attachments" in message.payload.message)
  ) {
    return null;
  }

  return message.payload.message.attachments.map((attachment) => {
    let mimetype: string | undefined;
    let name = "";
    let attachmentType: ChatMessageAttachmentType | undefined;
    switch (attachment.type) {
      case InstagramMessageType.image:
        mimetype = "image/*";
        name = t({ id: "common.image", defaultMessage: "Image" });
        attachmentType = ChatMessageAttachmentType.image;
        break;
      case InstagramMessageType.video:
        mimetype = "video/*";
        name = t({ id: "common.video", defaultMessage: "Video" });
        attachmentType = ChatMessageAttachmentType.video;
        break;
      case InstagramMessageType.audio:
        mimetype = "audio/*";
        name = t({ id: "common.audio", defaultMessage: "Audio" });
        attachmentType = ChatMessageAttachmentType.audio;
        break;
      default:
        throw new Error("Unsupported attachment type");
    }
    if (!mimetype) {
      mimetype = "application/octet-stream";
    }

    return {
      type: attachmentType,
      name,
      url: `${environment.apiUrl}/api/${entityId}/agents/instagram/media?id=${attachment.media_id}`,
      mimetype,
      size: 0,
      uid: attachment.media_id,
    };
  });
};
